import React from 'react'
import NuDate from '../../../../Components/Utils/NuDate';

function ViewEmailSent({ item, data, open, onCancel }) {
  // Use item if it exists, otherwise fall back to data
  const displayItem = item || data;

  return (
    <div className="w-full flex flex-col flex-wrap ">
      <div className='my-1 flex'>
        <p className='w-[20%] text-[13px] font-normal text-mainColor-400 '>Date</p>
        <p className='w-[65%] text-xs font-medium text-mainColor-300'>: {displayItem?.date ? (
                    <NuDate value={displayItem?.date} format="DD-MMM-YYYY, hh:mm A" />
                  ) : (
                    "N/A"
                  )}</p>
      </div>
      <div className='my-1 flex'>
        <p className='w-[20%] text-[13px] font-normal text-mainColor-400 '>TO</p>
        <p className='w-[65%] text-xs font-medium text-mainColor-300'>: {displayItem?.to || "-"}</p>
      </div>
      <div className='my-1 flex'>
        <p className='w-[20%] text-[13px] font-normal text-mainColor-400 '>CC</p>
        <p className='w-[65%] text-xs font-medium text-mainColor-300'>: {displayItem?.cc || "-"}</p>
      </div>
      <div className='my-1 flex'>
        <p className='w-[20%] text-[13px] font-normal text-mainColor-400 '>Subject</p>
        <p className='w-[65%] text-xs font-medium text-mainColor-300'>: {displayItem?.subject|| "-"}</p>
      </div>
    </div>
  );
}
export default ViewEmailSent
